module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-32.2cdba9b3.png";